document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener("click", e => {
      e.preventDefault();
      const target = document.getElementById(link.getAttribute("href").substring(1));
      if (!target) return;

      requestAnimationFrame(() => {
        const offset = 140;
        const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: topPosition, behavior: "smooth" });
      });
    });
  });

  //klaviyo out of stock button
  setTimeout(function() {
          console.log('RUNNNINGGGG')

    let ATCsubmitButton = document.querySelector('.product__info-container .product-form__submit');
    let bisTrigger = document.querySelector('.product__info-container .klaviyo-bis-trigger');
      
    if (ATCsubmitButton && bisTrigger) {
      if (!ATCsubmitButton.hasAttribute('disabled')) {
        bisTrigger.style.display = 'none';
        console.log('HIDDEEEEEN')
      }
    }
  }, 300)
});
